import React, { Component } from "react";
import { axiosPost } from "../../../../utils/AxiosApi";
import {
  URL,
  checkWidgetAdminOrNot,
  postType,
} from "../../../../utils/Constants";

import { Collapse, Card, CardBody, Spinner } from "reactstrap";
import { showErroMessage } from "../../../../utils/Utils";
import ReportGeneratorUI from "./ReportGeneratorUI";
import swal from "sweetalert";
import ModalWindow from "./../../../UI/ModalWindow";
import GranularPermissionModal from "./../../../Permissions/GranularPermissionModal";

import swal2 from "sweetalert2";
import { connect } from "react-redux";
import { getYearLevelForPublishAssessmentReport } from "../../../../ducks/PrimaryARRDucks";
import { getNotices } from "../../../../ducks/PostsDucks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { MESSAGEHEADER } from "../../../../utils/DisplayMessage";

class ReportGenerator extends Component {
  state = {
    yearLevels: [],
    isOpen: false,
    classrooms: [],
    assessmentList: [],
    assessmentName: "",
    studentList: [],
    reportSetups: [],
    templateSetup: [],
    reportSetupId: "",
    studentIds: [],
    zipHref: null,
    recruitmentId: null,
    loggedIdUserRecruitmentId: {},
    allStudentChecked: false,
    // new states
    classroomId: null,
    educationLevelDivisionId: null,
    educationLevelId: null,
    yearLevelId: null,
    studentsList: [],
    subjectAllData: [],
    assessmentDataLoader: false,
    subjectAllDatas: [],
    studentsLists: [],
    reportValues: [],
  };

  getLoggedInRecruitmentId = () => {
    let param = {
      peopleId: localStorage.getItem("peopleId"),
    };
    axiosPost(URL.selectRecruitmentByPeopleId, param, (response) => {
      if (response.status === 200) {
        this.setState({ loggedIdUserRecruitmentId: response.data.data });
      }
    });
  };

  componentDidMount() {
    this.getLoggedInRecruitmentId();
    this.props.getYearLevelForPublishAssessmentReport(this.props.code);
    // let param = {
    //   assessmentModuleCode: this.props.code,
    // };
    // axiosPost(URL.selectFinalizedAssessmentYearLevel, param, (response) => {
    //   if (response.status === 200) {
    //     const yearLevels = response.data.data;
    //     this.setState(
    //       {
    //         yearLevels,
    //       },
    //       () => {
    //         let yearLevels = [...this.state.yearLevels];
    //         yearLevels.forEach((level) => {
    //           level.isYearLevelOpen = false;
    //           level.classroomYearLevelRecruitmentRoom.forEach((classroom) => {
    //             classroom.isClassroomOpen = false;
    //           });
    //         });
    //         this.setState({ yearLevels });
    //       }
    //     );
    //   }
    // });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return { yearLevels: nextProps.yearLevels };
  }

  toggleCollapse = (e, idx, yearLevelId) => {
    // this.getClassroom(yearLevelId);
    let yearLevels = [...this.state.yearLevels];
    yearLevels.forEach((yearLevel, i) => {
      yearLevel.classroomYearLevelRecruitmentRoom.forEach((classroom) => {
        classroom.isClassroomOpen = false;
      });
      idx === i
        ? (yearLevel.isYearLevelOpen = !yearLevel.isYearLevelOpen)
        : (yearLevel.isYearLevelOpen = false);
    });
    this.setState({
      yearLevels,
    });
  };

  getAssessments = (classroomId, yearLevelId, educationLevelId) => {
    let param = {
      classroomId: classroomId,
      yearLevelId: yearLevelId,
      educationLevelId: educationLevelId,
    };

    axiosPost(
      URL.selectFinalizedGeneralAndSubjectAssessment,
      param,
      (response) => {
        if (response.status === 200) {
          this.setState({ assessmentList: response.data.data });
        }
      },
    );
  };

  getStudents = (e, classroomId, yearLevelId) => {
    let param = {
      classroomId: classroomId,
      yearLevelId: yearLevelId,
    };

    axiosPost(URL.getAssignedStudents, param, (response) => {
      if (response.status === 200) {
        this.setState({ studentList: response.data.data });
      } else {
        showErroMessage(response);
      }
    });
  };
  toggleClassroomCollapse = (
    e,
    index,
    classroomId,
    yearLevelId,
    educationLevelId,
  ) => {
    this.getAssessments(classroomId, yearLevelId, educationLevelId);
    this.getStudents(classroomId, yearLevelId);
    let classrooms = [...this.state.classrooms];
    classrooms.forEach((classroom, i) => {
      index === i
        ? (classroom.isClassroomOpen = !classroom.isClassroomOpen)
        : (classroom.isClassroomOpen = false);
    });
    this.setState({ classrooms }, () => {
      this.setState({
        assessmentName: "",
        reportSetupId: "",
        reportSetups: [],
        templateSetup: [],
      });
    });
  };

  toggleClassroom = (e, mainIdx, classIdx) => {
    let yearLevels = [...this.state.yearLevels];
    yearLevels.forEach((yearLevel, yearLevelIdx) => {
      if (parseInt(mainIdx) === parseInt(yearLevelIdx)) {
        yearLevel.classroomYearLevelRecruitmentRoom.forEach(
          (classroom, classroomIndex) => {
            if (parseInt(classIdx) === parseInt(classroomIndex)) {
              classroom.isClassroomOpen = !classroom.isClassroomOpen;
            } else {
              classroom.isClassroomOpen = false;
            }
          },
        );
      }
    });
    this.setState({ yearLevels }, () => {
      this.setState({
        assessmentName: "",
        reportSetupId: "",
        reportSetups: [],
        templateSetup: [],
      });
    });
  };

  // getClassroom = (yearLevelId) => {
  //   let param = {
  //     yearLevelId: yearLevelId,
  //   };

  //   axiosPost(
  //     URL.selectGeneralSubjectAssessmentFinalizedClassroom,
  //     param,
  //     (response) => {
  //       if (response.status === 200) {
  //         const classrooms = response.data.data;
  //         this.setState({ classrooms }, () => {
  //           let classrooms = [...this.state.classrooms];
  //           classrooms.forEach((classroom) => {
  //             classroom.isClassroomOpen = false;
  //           });
  //           this.setState({ classrooms });
  //         });
  //       } else {
  //         showErroMessage(response);
  //       }
  //     }
  //   );
  // };

  handleAssessmentChange = (e, yearLevelId) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let yearLevel = this.state?.yearLevels?.filter(
      (item) => item?.id === this.state?.yearLevelId,
    )[0];
    let classId = yearLevel?.classroomYearLevelRecruitmentRoom?.filter(
      (item) => item?.id === this.state?.classroomId,
    )[0];
    let education = classId?.assessments?.filter(
      (item) => item?.id === parseInt(e.target.value),
    )[0];

    let educationId = education?.educationLevelId;
    let educationDivisionId = education?.educationLevelDivisionId;

    this.setState(
      {
        [name]: value,
        educationLevelId: educationId,
        educationLevelDivisionId: educationDivisionId,
      },
      () => {
        this.getReportSetups(yearLevelId);
        this.getSubjectsNewApi(yearLevelId);
        this.getStudentDataNewApi(yearLevelId);
        // this.getAssessments(classroomId, yearLevelId, educationLevelId);
      },
    );
  };

  getAssessmentReportValues = () => {
    let filtredTemplate = this.state.templateSetup.filter(
      (template) => template.name === this.state?.reportSetupId,
    );
    if (!!filtredTemplate.length) {
      let param = {
        assessmentId: parseInt(this.state.assessmentName),
        classroomId: this.state?.classroomId,
        assessmentReportTemplateId: filtredTemplate[0].id,
        yearLevelId: this.state?.yearLevelId,
      };
      axiosPost(
        URL.getAssessmentReportValues,
        param,
        (response) => {
          if (response.status === 200) {
            this.setState({
              reportValues: response.data,
            });
          }
        },
        (err) => {
          swal({
            title: "Error",
            text: `${err}`,
          });
        },
      );
    }
  };

  universalHandleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value }, () => {
      if (name === "reportSetupId") {
        let reportSetups = [...this.state.reportSetups];
        reportSetups.forEach((setup) => {
          if (parseInt(setup.id) === parseInt(this.state.reportSetupId)) {
            this.setState({ recruitmentId: setup.recruitmentId });
          }
        });
        this.getAssessmentReportValues();
      }
    });
  };

  getReportSetups = (yearLevelId) => {
    let param = {
      assessmentId: parseInt(this.state.assessmentName),
      classroomId: this.state.classroomId,

      educationLevelDivisionId: this.state?.educationLevelDivisionId,
      educationLevelId: this.state?.educationLevelId,

      yearLevelId: yearLevelId,
      forReport: true,
    };

    let paramForSetups = {
      yearLevelId: yearLevelId,
      assessmentId: parseInt(this.state.assessmentName),
    };

    axiosPost(URL.getReportSetupTemplate, {}, (response) => {
      if (response.status === 200) {
        const templateData =
          response.data.data.length > 0
            ? response.data.data.map((item) => ({
                ...item,
                isTemplate: true,
              }))
            : [];
        this.setState({ templateSetup: templateData });
      }
    });

    axiosPost(URL.selectByReportSetupYearLevel, paramForSetups, (response) => {
      if (response.status === 200) {
        this.setState({ reportSetups: response?.data?.data });
      }
    });

    this.setState({ assessmentDataLoader: true });
    axiosPost(URL.getSubjectWithScaleOrComment, param, (response) => {
      if (response.status === 200) {
        // this.setState({ reportSetups: response.data.data });
        // let studentsList = response.data.data?.flatMap((item) => item.students);
        // const uniqueStudentsList = [...new Set(studentsList.map(JSON.stringify))].map(JSON.parse);
        // this.setState({ studentsList: uniqueStudentsList })
        let subjects = response.data.data;
        let temData = {};
        let finalizeCheck = {};

        subjects.forEach((item) => {
          let theory = [];
          let practical = [];

          let t = item.students?.forEach((student) => {
            let finalizeTheory =
              item?.theorySubjectAssessments?.length > 0
                ? item.theorySubjectAssessments.some((item) => item.isFinalized)
                : false;
            let finalizePractical =
              item?.practicalSubjectAssessments?.length > 0
                ? item.practicalSubjectAssessments.some(
                    (item) => item.isFinalized,
                  )
                : false;
            let finalize = finalizeTheory || finalizePractical;

            item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.forEach(
              (d) => {
                let theoryData = item.theorySubjectAssessments.find(
                  (itm) =>
                    itm.assessmentScaleId == d.id &&
                    itm.admissionId == student.admissionId,
                );
                if (
                  typeof theoryData == "object" &&
                  typeof theoryData !== null
                ) {
                  theory.push({
                    ...theoryData,
                    assessmentScale: d,
                    assessmentScaleTypeCode: d.assessmentScaleTypeCode,
                    uniqueId: Math.random(),
                  });
                } else {
                  theory.push({
                    assessmentScaleId: d.id,
                    admissionId: student.admissionId,
                    isTheoryAbsent: false,
                    uniqueId: Math.random(),
                    assessmentScaleLevelTheoryId: "",
                    assessmentScaleGradePointTheoryId: "",
                    theoryObtainedMarks: 0,
                    isFinalized: finalize,
                    assessmentScale: d,
                    assessmentScaleTypeCode: d.assessmentScaleTypeCode,
                  });
                }
              },
            );
            item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.forEach(
              (d) => {
                let practicalData = item.practicalSubjectAssessments.find(
                  (itm) =>
                    itm.assessmentScaleId == d.id &&
                    itm.admissionId == student.admissionId,
                );
                if (
                  typeof practicalData == "object" &&
                  typeof practicalData !== null
                ) {
                  practical.push({
                    ...practicalData,
                    assessmentScale: d,
                    assessmentScaleTypeCode: d.assessmentScaleTypeCode,
                    uniqueId: Math.random(),
                  });
                } else {
                  practical.push({
                    assessmentScaleId: d.id,
                    admissionId: student.admissionId,
                    isPracticalAbsent: false,
                    uniqueId: Math.random(),
                    assessmentScaleLevelPracticalId: "",
                    assessmentScaleGradePointPracticalId: "",
                    practicalObtainedMarks: 0,
                    isFinalized: finalize,
                    assessmentScale: d,
                    assessmentScaleTypeCode: d.assessmentScaleTypeCode,
                  });
                }
              },
            );
          });
          temData[item.name] = {
            theory: theory,
            practical: practical,
          };
          finalizeCheck[item.name] =
            item?.theorySubjectAssessments?.length > 0 ||
            item?.practicalSubjectAssessments?.length > 0;
        });

        // setSubjectFinalize(finalizeCheck);

        let finalSubjectData = subjects.map((item) => ({
          ...item,
          theorySubjectAssessments: temData[item.name].theory,
          practicalSubjectAssessments: temData[item.name].practical,
        }));

        // setAllData(finalSubjectData);
        this.setState({ subjectAllData: finalSubjectData });

        let Students = [];

        let test = finalSubjectData?.forEach((item) =>
          item?.students.forEach((data) => {
            if (
              typeof Students?.find(
                (el) => el.admissionId == data.admissionId,
              ) == "object" &&
              Students?.find((el) => el.admissionId == data.admissionId) !==
                null
            ) {
              Students = Students.map((std) => {
                if (std.admissionId === data.admissionId) {
                  return {
                    ...std,
                    subject: {
                      ...std.subject,
                      [item.name]: finalSubjectData
                        .filter((itm) => itm.name == item.name)
                        .map((d) => ({
                          ...d,
                          practicalSubjectAssessments:
                            item.hasPractical &&
                            d.practicalSubjectAssessments?.length > 0
                              ? d.practicalSubjectAssessments.filter(
                                  (itm) => itm.admissionId == data.admissionId,
                                )
                              : [],
                          theorySubjectAssessments:
                            item.hasTheory &&
                            d.theorySubjectAssessments?.length > 0
                              ? d.theorySubjectAssessments.filter(
                                  (itm) => itm.admissionId == data.admissionId,
                                )
                              : [],
                        })),
                    },
                  };
                }
                return std;
              });
            } else {
              Students.push({
                ...data,
                subject: {
                  [item.name]: finalSubjectData
                    .filter((itm) => itm.name == item.name)
                    .map((d) => ({
                      ...d,
                      practicalSubjectAssessments:
                        item.hasPractical &&
                        d.practicalSubjectAssessments?.length > 0
                          ? d.practicalSubjectAssessments.filter(
                              (itm) => itm.admissionId == data.admissionId,
                            )
                          : [],
                      theorySubjectAssessments:
                        item.hasTheory && d.theorySubjectAssessments?.length > 0
                          ? d.theorySubjectAssessments.filter(
                              (itm) => itm.admissionId == data.admissionId,
                            )
                          : [],
                    })),
                },
              });
            }
          }),
        );
        this.setState({ studentsList: Students, assessmentDataLoader: false });
      }
    });
  };

  handlePublishReport = (
    yearLevelId,
    classroomId,
    selectedPublishDate,
    isAggregation,
  ) => {
    let studentsLists = [...this.state.studentsLists];

    let studentIds = [];
    studentsLists.forEach((student, i) => {
      let data = {};
      if (student.checked) {
        // data.studentId = student.people.id;
        data = student.id;
        studentIds.push(data);
      }
    });
    if (studentIds.length > 0) {
      this.setState({ studentIds }, () => {
        //   for (let i = 0; i < this.state.studentIds.length; i++) {
        let param = {
          yearLevelId: parseInt(yearLevelId),
          classroomId: parseInt(classroomId),
          assessmentId: parseInt(this.state.assessmentName),
          reportSetupId: parseInt(this.state.reportSetupId),
          admissionIds: this.state.studentIds,
          publishDate: selectedPublishDate,
          isAggregated: isAggregation,
        };

        let reportTemplate = this.state.templateSetup.filter(
          (item) => item.name === this.state.reportSetupId,
        );
        if (reportTemplate.length > 0) {
          let reportTemplateParam = {
            assessmentId: parseInt(this.state.assessmentName),
            admissionIds: this.state.studentIds,
            assessmentReportTemplateId: reportTemplate[0].id,
            isPublish: 1,
            publishDate: selectedPublishDate,
            isAggregated: isAggregation,
          };

          this.setState({ showSpinner: true }, function () {
            axiosPost(
              URL.generateReportTemplate,
              reportTemplateParam,
              (response) => {
                if (response.status === 200) {
                  let zipFolderName =
                    response.data !== ""
                      ? response.data.data !== null || response.data.data !== ""
                        ? response.data.data
                        : "zipFolder.zip"
                      : "zipFolder.zip";
                  this.setState({
                    zipHref: URL.downloadReport + zipFolderName,
                  });
                  let texts = `<p>Report has been successfully published<br>
                  <button 
                 class="tt-button tt-button-primary" 
                 onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
                 Download Files
                 </button>
                  </p>`;
                  swal2.fire({
                    title: "Success",
                    html: texts,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                  });

                  let yearLevels = [...this.state.yearLevels];
                  yearLevels.forEach((yearLevel) => {
                    yearLevel.classroomYearLevelRecruitmentRoom.forEach(
                      (classroom) => {
                        classroom.isClassroomOpen = false;
                      },
                    );
                  });
                  let param = {
                    postType: postType.noticeCode,
                    createdAt: new Date(),
                    peopleId: localStorage.getItem("peopleId"),
                  };
                  this.props.getNotices(param);

                  const unCheckedStudentsLists = this.state.studentsLists?.map(
                    (item) => ({ ...item, checked: false }),
                  );

                  this.setState({
                    yearLevels,
                    showSpinner: false,
                    allStudentChecked: false,
                    studentsLists: unCheckedStudentsLists,
                  });
                  // swal("success", "Report has been successfully generated");
                } else {
                  swal("Oops", "Error downloading");
                }
              },
              (failure) => {
                swal({
                  title: "Oops",
                  text: failure.response.data.message,
                });
                this.setState({ showSpinner: false });
              },
            );
          });
        } else {
          this.setState({ showSpinner: true }, function () {
            axiosPost(
              URL.publishReport,
              param,
              (response) => {
                if (response.status === 200) {
                  // let noticeParam = {
                  //   createdAt: new Date(),
                  //   postType: "PT_NOTE",
                  //   peopleId: localStorage.getItem("peopleId"),
                  // };

                  // this.props.getNotices(noticeParam);
                  // swal(MESSAGEHEADER.success, "Report successfully published");

                  let zipFolderName =
                    response.data !== ""
                      ? response.data.data !== null || response.data.data !== ""
                        ? response.data.data
                        : "zipFolder.zip"
                      : "zipFolder.zip";
                  this.setState({
                    zipHref: URL.downloadReport + zipFolderName,
                  });
                  // modified text to add a btn inside warning for downloading the ready file.
                  let texts = `<p>Report successfully published<br>
                 <button 
                 class="tt-button tt-button-primary" 
                 onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
                 Download Files
                 </button>
                  </p>`;

                  swal2.fire({
                    title: "Success",
                    html: texts,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                  });

                  let yearLevels = [...this.state.yearLevels];
                  yearLevels.forEach((yearLevel) => {
                    yearLevel.classroomYearLevelRecruitmentRoom.forEach(
                      (classroom) => {
                        classroom.isClassroomOpen = false;
                      },
                    );
                  });
                  let param = {
                    postType: postType.noticeCode,
                    createdAt: new Date(),
                    peopleId: localStorage.getItem("peopleId"),
                  };
                  this.props.getNotices(param);

                  const unCheckedStudentsLists = this.state.studentsLists?.map(
                    (item) => ({ ...item, checked: false }),
                  );

                  this.setState({
                    yearLevels,
                    showSpinner: false,
                    allStudentChecked: false,
                    studentsLists: unCheckedStudentsLists,
                  });

                  // swal("success", "Report has been successfully generated");
                } else {
                  swal("Oops", "Error downloading");
                }
              },
              (failure) => {
                swal({
                  title: "Oops",
                  text: "Error publishing",
                });
                this.setState({ showSpinner: false });
              },
            );
          });
        }

        //   }
      });
    } else {
      swal("Oops", "Check atleast one student");
    }
  };

  handleGenerateReport = (
    yearLevelId,
    classroomId,
    selectedPublishDate,
    isAggregation,
  ) => {
    let studentsLists = [...this.state.studentsLists];

    let studentIds = [];
    studentsLists.forEach((student, i) => {
      let data = {};
      if (student.checked) {
        // data.studentId = student.people.id;
        data = student.id;
        studentIds.push(data);
      }
    });
    if (studentIds.length > 0) {
      this.setState({ studentIds }, () => {
        //   for (let i = 0; i < this.state.studentIds.length; i++) {
        let param = {
          yearLevelId: parseInt(yearLevelId),
          classroomId: parseInt(classroomId),
          assessmentId: parseInt(this.state.assessmentName),
          reportSetupId: parseInt(this.state.reportSetupId),
          admissionIds: this.state.studentIds,
          publishDate: selectedPublishDate,
          isAggregated: isAggregation,
        };

        let reportTemplate = this.state.templateSetup.filter(
          (item) => item.name == this.state.reportSetupId,
        );
        if (reportTemplate.length > 0) {
          let reportTemplateParam = {
            assessmentId: parseInt(this.state.assessmentName),
            admissionIds: this.state.studentIds,
            assessmentReportTemplateId: reportTemplate[0].id,
            isPublish: 0,
            publishDate: selectedPublishDate,
            isAggregated: isAggregation,
          };

          this.setState({ showSpinner: true }, function () {
            axiosPost(
              URL.generateReportTemplate,
              reportTemplateParam,
              (response) => {
                if (response.status === 200) {
                  let zipFolderName =
                    response.data !== ""
                      ? response.data.data !== null || response.data.data !== ""
                        ? response.data.data
                        : "zipFolder.zip"
                      : "zipFolder.zip";
                  this.setState({
                    zipHref: URL.downloadReport + zipFolderName,
                  });
                  let texts = `<p>Report has been successfully generated<br>
                  <button 
                 class="tt-button tt-button-primary" 
                 onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
                 Download Files
                 </button>
                  </p>`;
                  swal2.fire({
                    title: "Success",
                    html: texts,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                  });
                  let yearLevels = [...this.state.yearLevels];
                  yearLevels.forEach((yearLevel) => {
                    yearLevel.classroomYearLevelRecruitmentRoom.forEach(
                      (classroom) => {
                        classroom.isClassroomOpen = false;
                      },
                    );
                  });

                  const unCheckedStudentsLists = this.state.studentsLists?.map(
                    (item) => ({ ...item, checked: false }),
                  );

                  this.setState({
                    yearLevels,
                    showSpinner: false,
                    allStudentChecked: false,
                    studentsLists: unCheckedStudentsLists,
                  });
                  // swal("success", "Report has been successfully generated");
                } else {
                  this.setState({ showSpinner: false });
                  swal("Oops", "Error downloading");
                }
              },
              (failure) => {
                swal({
                  title: "Oops",
                  text: failure.response.data.message,
                });
                this.setState({ showSpinner: false });
              },
            );
          });
        } else {
          this.setState({ showSpinner: true }, function () {
            axiosPost(
              URL.generateReport,
              param,
              (response) => {
                if (response.status === 200) {
                  let zipFolderName =
                    response.data !== ""
                      ? response.data.data !== null || response.data.data !== ""
                        ? response.data.data
                        : "zipFolder.zip"
                      : "zipFolder.zip";
                  this.setState({
                    zipHref: URL.downloadReport + zipFolderName,
                  });
                  let texts = `<p>Report has been successfully generated<br>
                  <button 
                 class="tt-button tt-button-primary" 
                 onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
                 Download Files
                 </button>
                  </p>`;
                  swal2.fire({
                    title: "Success",
                    html: texts,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                  });
                  let yearLevels = [...this.state.yearLevels];
                  yearLevels.forEach((yearLevel) => {
                    yearLevel.classroomYearLevelRecruitmentRoom.forEach(
                      (classroom) => {
                        classroom.isClassroomOpen = false;
                      },
                    );
                  });

                  const unCheckedStudentsLists = this.state.studentsLists?.map(
                    (item) => ({ ...item, checked: false }),
                  );

                  this.setState({
                    yearLevels,
                    showSpinner: false,
                    allStudentChecked: false,
                    studentsLists: unCheckedStudentsLists,
                  });
                  // swal("success", "Report has been successfully generated");
                } else {
                  this.setState({ showSpinner: false });
                  swal("Oops", "Error downloading");
                }
              },
              (failure) => {
                swal({
                  title: "Oops",
                  text: failure.response.data.message,
                });
                this.setState({ showSpinner: false });
              },
            );
          });
        }
      });
    } else {
      swal("Oops", "Check atleast one student");
    }
  };

  handleSelectAllCheckBoxClick = (e) => {
    let studentsLists = this.state.studentsLists;
    studentsLists.forEach((student, i) => {
      student.checked = e.target.checked;
    });
    this.setState({
      studentsLists,
      allStudentChecked: e.target.checked,
    });
  };

  handlSelectRowCheckBoxClick = (e, studentId) => {
    let studentsLists = [...this.state.studentsLists];
    let allChecked = true;

    studentsLists.forEach((student, i) => {
      if (student.people.id === studentId) {
        student.checked = e.target.checked;
      }
      if (!student.checked) {
        allChecked = false;
      }
    });

    this.setState({
      studentsLists,
      allStudentChecked: allChecked,
    });
  };

  getSubjectsNewApi = (yearLevelId) => {
    let payload = {
      assessmentId: parseInt(this.state.assessmentName),
      classroomId: this.state.classroomId,
      educationLevelDivisionId: this.state?.educationLevelDivisionId,
      educationLevelId: this.state?.educationLevelId,
      yearLevelId: yearLevelId,
    };
    axiosPost(
      URL.selectSystemExamSubjects,
      payload,
      (response) => {
        if (response.status === 200) {
          this.setState({
            subjectAllDatas: response.data.data,
          });
        }
      },
      (err) => {
        swal({
          title: "Error",
          text: `${err}`,
        });
        // console.log(err);
      },
    );
  };

  getStudentDataNewApi = (yearLevelId) => {
    let payload = {
      assessmentId: parseInt(this.state.assessmentName),
      classroomId: this.state.classroomId,
      educationLevelDivisionId: this.state?.educationLevelDivisionId,
      educationLevelId: this.state?.educationLevelId,
      yearLevelId: yearLevelId,
      // admissionId:"1415"
    };

    axiosPost(
      URL.getStudentWithAssessmentRoutine,
      payload,
      (response) => {
        if (response.status === 200) {
          this.setState({
            studentsLists: response.data.data,
          });
        }
      },
      (err) => {
        swal({
          title: "Error",
          text: `${err}`,
        });
      },
    );
  };

  render() {
    return (
      <div
        className="tt-widgetContent-tab-holder"
        style={{ height: "79.5vh", width: "84vw" }}
      >
        <div className="tt-group-header">
          Publish Assessment Report
          {checkWidgetAdminOrNot(this.props.name) === true ? (
            <button
              className="tt-button tt-button-primary float-right permissionBtnCSS"
              onClick={() => {
                this.setState({
                  permissionModal: !this.state.permissionModal,
                });
              }}
            >
              Permissions
            </button>
          ) : null}
        </div>
        <div className="tt-newListBox">
          {this.state.yearLevels.length > 0 ? (
            this.state.yearLevels.map((yearLevel, idx) => {
              return (
                <div className="container-fluid">
                  <div
                    onClick={(e) => {
                      this.setState({ yearLevelId: yearLevel.id });
                      this.toggleCollapse(e, idx, yearLevel.id);
                    }}
                    key={idx}
                    className="row tt-group-header text-left"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="col">Class {yearLevel.name}</div>
                    <div className="col-md-1 text-center">
                      <FontAwesomeIcon
                        icon={
                          yearLevel.isYearLevelOpen ? faAngleUp : faAngleDown
                        }
                      ></FontAwesomeIcon>
                    </div>
                  </div>

                  <Collapse isOpen={yearLevel.isYearLevelOpen}>
                    <Card>
                      <CardBody>
                        {yearLevel.classroomYearLevelRecruitmentRoom
                          ? yearLevel.classroomYearLevelRecruitmentRoom.map(
                              (classroom, classIdx) => {
                                return (
                                  <>
                                    <div
                                      key={classIdx}
                                      className="tt-group-header text-left"
                                      onClick={(e) => {
                                        this.setState({
                                          classroomId: classroom.id,
                                        });
                                        this.toggleClassroom(e, idx, classIdx);
                                        // this.getStudents(
                                        //   e,
                                        //   classroom.id,
                                        //   classroom.yearLevelId
                                        // );
                                      }}
                                    >
                                      {classroom.name}
                                    </div>

                                    <ReportGeneratorUI
                                      allStudentChecked={
                                        this.state.allStudentChecked
                                      }
                                      isClassroomOpen={
                                        classroom.isClassroomOpen
                                      }
                                      handleAssessmentChange={
                                        this.handleAssessmentChange
                                      }
                                      assessmentName={this.state.assessmentName}
                                      assessmentList={classroom.assessments}
                                      studentList={this.state.studentList}
                                      yearLevelId={yearLevel.id}
                                      classroomId={classroom.id}
                                      reportSetups={this.state.reportSetups}
                                      templateSetup={this.state.templateSetup}
                                      reportSetupId={this.state.reportSetupId}
                                      handleGenerateReport={
                                        this.handleGenerateReport
                                      }
                                      zipHref={this.state.zipHref}
                                      universalHandleChange={
                                        this.universalHandleChange
                                      }
                                      handleSelectAllCheckBoxClick={
                                        this.handleSelectAllCheckBoxClick
                                      }
                                      handlSelectRowCheckBoxClick={
                                        this.handlSelectRowCheckBoxClick
                                      }
                                      recruitmentId={this.state.recruitmentId}
                                      loggedIdUserRecruitmentId={
                                        this.state.loggedIdUserRecruitmentId
                                      }
                                      handlePublishReport={
                                        this.handlePublishReport
                                      }
                                      showSpinner={this.state.showSpinner}
                                      name={this.props.name}
                                      studentsList={this.state.studentsList}
                                      subjectAllData={this.state.subjectAllData}
                                      assessmentDataLoader={
                                        this.state.assessmentDataLoader
                                      }
                                      yearLevels={this.state.yearLevels}
                                      subjectAllDatas={
                                        this.state.subjectAllDatas
                                      }
                                      studentsLists={this.state.studentsLists}
                                      reportValues={this.state.reportValues}
                                    />
                                  </>
                                );
                              },
                            )
                          : `No classroom for this ${localStorage.getItem(
                              "yearLevel",
                            )}`}
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
              );
            })
          ) : this.props.publishAssessmentReportSpinner ? (
            <div className="text-center">
              <Spinner color="primary"></Spinner>
              <br></br>Loading Data...
            </div>
          ) : (
            <div className="text-center">No records found.</div>
          )}
        </div>
        <ModalWindow
          modal={this.state.permissionModal}
          size="lg"
          id="tt-permissionModal"
          toggleModal={() => {
            this.setState({
              permissionModal: !this.state.permissionModal,
            });
          }}
          modalHeader={"Assign permission to user"}
          modalBody={
            <GranularPermissionModal
              widgetName={this.props.name}
              moduleName="Reports"
              header="Create Assessment Report"
              activityName="publish-assessment-report"
            />
          }
        ></ModalWindow>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  yearLevels: state.primaryArr.yearLevels,
  publishAssessmentReportSpinner:
    state.primaryArr.publishAssessmentReportSpinner,
});

const mapActionsToProps = {
  getYearLevelForPublishAssessmentReport:
    getYearLevelForPublishAssessmentReport,
  getNotices: getNotices,
};

export default connect(mapStateToProps, mapActionsToProps)(ReportGenerator);
